import { ContractorItem } from '../bus/contractor/types';
import { ContractorIndividualItem } from '../bus/contractorIndividual/types';
import { ContractorLegalItem } from '../bus/contractorLegal/types';
import $axios from '../utils/axios-instance';

export default class ContractorsApi {
  async getContractorList() {
    return await $axios
      .get<{ data: ContractorItem[] }>('/v1/Contractor')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getContractorDetailInfo(data: { id: number | string }) {
    return await $axios
      .get<ContractorIndividualItem | ContractorLegalItem>(`/v1/Contractor/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
